// extracted by mini-css-extract-plugin
module.exports = {"CompanyHeader":"_17JzeRdR","headerLogoContainer":"a0ZSRzpN","headerDetailsContainer":"_2OF71YEt","headerName":"_2YD5FEbS","headerIndustry":"_Md0828A","headerTagline":"_214YRH4_","headerDetailContainer":"zB2H23Rs","headerDeets":"_2nGF612f","headerDetail":"_3NJCW8pw","headerDetailBull":"zP1oTZbF","headerLink":"AzhfCueH","sizeMax":"_3zKIeEHG"};
    if(module.hot) {
      // 1746735880669
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  